import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL || "https://placeholder.supabase.co";
const key = process.env.REACT_APP_SUPABASE_ANON_KEY || "placeholder-anon-key";

if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  console.warn("Supabase env variables missing — falling back to placeholders (auth will not work)");
}

/* Single Supabase client (persistent) — one GoTrueClient per browser context. */
export const supabase = createClient(url, key, {
  auth: { persistSession: true, storageKey: "r4pro-auth" },
});

export function getActiveClient() {
  return supabase;
}
